import { CompactUser } from "../../../core/CompactModels";

export interface CategoryModel {
  id?: string;
  name?: string;
  description?: string;

  parentId?: string;

  creatorUserId?: string;
  creatorUser?: CompactUser;

  modifiedUserId?: string;
  modifiedUser?: CompactUser;

  fullPathName?: string;
  attributesCount?: number;

  createdAt?: Date;
  modifiedAt?: Date;
}

export interface CategoryCompact {
  id?: string;
  name?: string;
  fullPathName?: string;
}

export interface CategoryAttributeItem {
  id?: string
  catId?: string
  name?: string
  type?: CategoryAttributeTypes

  creatorUserId?: string
  creatorUser?: CompactUser

  modifiedUserId?: string
  modifiedUser?: CompactUser

  createdAt?: Date
  modifiedAt?: Date

}

export enum CategoryAttributeTypes {
  Text = 1, MultiLineText = 2, Numeric = 3, Boolean = 4
}